import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d67f491"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "info"
}
const _hoisted_2 = { class: "dialog-footer" }

import { onMounted, ref } from "vue";
import { useChatStore } from "@/store/chatStore";
import { useRouter } from "vue-router";
import Avatar from "@/components/Avatar.vue";
import GroupApi from "@/api/GroupApi";
import ChatType from "@/config/ChatType";
import Group from "@/mode/Group";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupModal',
  props: {
  groupId: {
    type: String,
    required: true,
    default: null,
  },
  showSend: {
    type: Boolean,
    required: false,
    default: false,
  },
  closeDialog: {
    type: Function,
    default: null,
  },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();
const store = useChatStore();

const open = ref(false);



const group = ref<Group>();
function getGroup(groupId: string) {
  GroupApi.get(groupId).then((res) => {
    group.value = res.data;
  });
}

onMounted(() => {
  if (props.groupId) {
    open.value = true;
    getGroup(props.groupId);
  }
});

const send = () => {
  if (group.value) {
    props.closeDialog();
    store.openChat({
      id: group.value.id,
      name: group.value.name,
      avatar: group.value.avatar,
      type: ChatType.GROUP,
      lastMessage: "",
      unreadCount: 0,
      isLoading: false,
      loaded: true,
    });
    router.push("/index/chat");
  }
};

const close = () => {
  props.closeDialog();
};

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_component_el_dialog, {
      modelValue: open.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((open).value = $event)),
      width: "40rem",
      center: "",
      "show-close": false,
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, { onClick: close }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          }),
          (__props.showSend)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (send()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("聊天")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        (group.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(Avatar, {
                img: group.value.avatar,
                name: group.value.name
              }, null, 8, ["img", "name"]),
              _createVNode(_component_el_descriptions, {
                class: "description",
                column: 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "群名" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(group.value.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "审核" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(group.value.needCheck === "0" ? "否" : "是"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})